import React, { Suspense, lazy } from 'react'
const FuelSurchargeCalculatorComp = lazy(() => import(/* webpackChunkName: "fuel-surcharge-calculator" */ './FuelSurchargeCalculatorComp'));

export default function FuelSurchargeCalculator(props) {
  return (
    <Suspense fallback={<div>Loading...</div>}>
      <FuelSurchargeCalculatorComp {...props} />
    </Suspense>
  )
}